const SUBMIT_INQUIRY = "inquiries/SUBMIT_INQUIRY";
const SUBMIT_INQUIRY_SUCCESS = "inquiries/SUBMIT_INQUIRY_SUCCESS";
const SUBMIT_INQUIRY_FAIL = "inquiries/SUBMIT_INQUIRY_FAIL";


const initialState = {
  pending: true,
  loaded: false,
  inquiries: {},
  error: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SUBMIT_INQUIRY:
      return Object.assign({}, state, {
        pending: true,
        loaded: false
      });
    case SUBMIT_INQUIRY_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        inquiries: { ...action.results },
        error: null
      });
    case SUBMIT_INQUIRY_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        error: action.error
      });

    default:
      return state;
  }
}

export function submitInquiryPending() {
  return {
    type: SUBMIT_INQUIRY
  };
}

export function submitInquirySuccess(results) {
  return {
    type: SUBMIT_INQUIRY_SUCCESS,
    results
  };
}

export function submitInquiryFail(error) {
  return {
    type: SUBMIT_INQUIRY_FAIL,
    error
  };
}

export const getError = state => state.error;
export const getPending = state => state.pending;
export const getLoaded = state => state.loaded;
